<div *ngIf="messages && messages.length > 0">
  <span class="label">{{ 'common.messages' | translate }}:</span>
  <ul>
    <li *ngFor="let message of messages">
      <span *ngIf="message.title" class="text-primary">
        {{ message.title }}:
      </span>
      <span>{{ message.message }}</span>
    </li>
  </ul>
</div>
